// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const ZendeskIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 48 48">
    <path
      fill="currentColor"
      d="M36.1 30.66A10.4 10.4 0 0 0 25.7 41.04v.01H46.5c0-5.74-4.66-10.39-10.4-10.39M22.3 15.96 1.5 41.06h20.78zm-20.78-9a10.39 10.39 0 1 0 20.78 0zm24.2-.01v25.1L46.5 6.94z"
    />
  </svg>,
  "Zendesk",
);
export default ZendeskIcon;
